// 新建文件，完整内容如下
import { reactive } from 'vue';

export default function usePagination(getTableData, searchForm) {
  return reactive({
    pageTotal: 0,
    pageChange(value) {
      searchForm.start = (value - 1) * searchForm.limit;
      getTableData();
    },
    handlePageChange(value) {
      searchForm.start = (value - 1) * searchForm.limit;
      getTableData();
    },
    onShowSizeChange(value) {
      searchForm.limit = value;
      getTableData();
    },
    handlePageSizeChange(value) {
      searchForm.limit = value;
      getTableData();
    },
  });
}
